import { useState } from 'react';

export const useFormSaveHandler = (
  baseUrl,
  slug,
  formFields,
  paquetes,
  deletedFields,
  selectedPaquete,
  title,
  amount
) => {
  const [error, setError] = useState(null);

  // 🔧 Función para actualizar fieldConditions de campos category
  const updateCategoryFieldConditions = (fields) => {
    return fields.map((field) => {
      // Solo procesar campos de tipo 'category'
      if (field.type !== 'category') return field;

      // Obtener todos los packageIds únicos de las categoryRules
      const packageIdsFromRules = new Set();
      (field.categoryRules || []).forEach((rule) => {
        if (rule.packageIds && rule.packageIds.length > 0) {
          rule.packageIds.forEach((id) => packageIdsFromRules.add(id));
        } else if (rule.packageId) {
          packageIdsFromRules.add(rule.packageId);
        }
      });

      // Si no hay rules con packageIds, no modificar
      if (packageIdsFromRules.size === 0) return field;

      const packageIdsArray = Array.from(packageIdsFromRules);

      // Actualizar fieldConditions existentes de tipo 'package'
      let hasPackageCondition = false;
      const updatedConditions = (field.fieldConditions || []).map((cond) => {
        if (cond.type === 'package' || cond.fieldId === 'packages') {
          hasPackageCondition = true;
          return {
            ...cond,
            options: packageIdsArray,
          };
        }
        return cond;
      });

      // Si no había condición de tipo 'package', crear una
      const finalConditions = hasPackageCondition
        ? updatedConditions
        : [
            ...updatedConditions,
            {
              fieldId: 'packages',
              targetFieldId: field.id,
              label: 'Paquete',
              options: packageIdsArray,
              type: 'package',
              value: packageIdsArray[0] || '',
            },
          ];

      return {
        ...field,
        fieldConditions: finalConditions,
      };
    });
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('Inicia sesión para continuar.');
        return false;
      }

      if (!slug || !formFields || !Array.isArray(formFields) || formFields.length === 0) {
        return false;
      }

      // 🔧 ACTUALIZAR fieldConditions de campos category
      const updatedFormFields = updateCategoryFieldConditions(formFields);

      const dbData = {
        fields: {
          fields: Array.isArray(updatedFormFields) ? updatedFormFields : [],
          conditions: [],
          packages: Array.isArray(paquetes) ? paquetes : [],
          deletedFields: Array.isArray(deletedFields) ? deletedFields : [],
        },
        conditions: [],
      };

      const dbResponse = await fetch(`${baseUrl}/forms/submit-form/${slug}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dbData),
      });

      if (!dbResponse.ok) {
        const errorResponse = await dbResponse.json();
        throw new Error(errorResponse.message || 'Error al guardar en la base de datos');
      }

      const jsonData = {
        slug,
        packages: selectedPaquete || '',
        title: title || '',
        amount: amount || '',
        formFields: updatedFormFields,
        fields: updatedFormFields.map((field) => ({
          ...field,
          fieldConditions: field.fieldConditions || [],
        })),
        deletedFields,
      };

      const jsonResponse = await fetch(`${baseUrl}/forms/save`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(jsonData),
      });

      if (!jsonResponse.ok) {
        const errorResponse = await jsonResponse.json();
        throw new Error(errorResponse.message || 'Error al guardar el JSON');
      }

      return true;
    } catch (err) {
      setError(err.message);
      alert('Hubo un problema al guardar el formulario: ' + err.message);
      return false;
    }
  };

  return { handleSave, error };
};